'use client'

import type { ComponentProps, ReactNode } from 'react'
import { Button } from '@/ui/Button'

/** Everything Button takes, minus what an icon-only button decides for itself. */
type Props = Omit<ComponentProps<typeof Button>, 'size' | 'icon' | 'aria-label'> & {
  /** Accessible name: the button shows an icon and no text. */
  label: string
  children: ReactNode
}

/** Round 36px icon button - direction swap, row actions. */
export function IconButton({ label, children, ...props }: Props) {
  return (
    <Button size="icon" aria-label={label} {...props}>
      {children}
    </Button>
  )
}
